<template>
  <div class="activateAccount">
    <v-parallax
      src="@/assets/header-parallax-1.jpg"
      height="200"
      class="page-header"
    >
      <v-container
        ><h1>
          {{ $t("texts.activeAccount") }}
        </h1></v-container
      >
    </v-parallax>
    <div class="page-content">
      <div class="page-section">
        <p>{{ response }}</p>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import AppError from "@/utils/AppError.js";

export default {
  name: "ActiveAccount",
  mounted: function() {
    this.confirmAccount();
  },
  data() {
    return {
      response: null
    };
  },
  methods: {
    confirmAccount() {
      let url = this.$config.api.route.activeAccount;
      url = url.replace(":token", this.$route.params.token);
      this.$api({
        url: url,
        method: "GET"
      })
        .then(() => {
          this.response = this.$t("texts.accountActive");
        })
        .catch(err => {
          AppError.handle(err);
        });
    }
  }
};
</script>
